const BASE_URL = 'https://docno-ap.hakaru-cloud.jp/v1'; // 本番環境API

export default BASE_URL;
